<template>
  <div
    :class="{
      'container mx-auto': true,
    }"
  >
    <div
      :class="{
        'uss-error-out mt-6': true,
      }"
    >
      <div
        :class="{
          'text-center text-xl font-semibold leading-9 text-www-color-neutral-medium-dark md:text-2xl md:leading-[2.6875rem] lg:text-5xl lg:leading-[5.4rem]': true,
        }"
      >
        {{ title }}
      </div>
      <component
        :is="getComponent(subtitle._type)"
        :value="subtitle"
        :class="{
          'my-6': true,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponent } from '~/components/Mapper';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type ErrorOutSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/ErrorOutSignupScreen';
import type { UssSuccessRedirect } from '~/sanity/types';
import ErrorUtil from '~/hekate-www/external/util/ErrorUtil';

defineProps<
  UssSuccessRedirect & {
    signupScreen: ErrorOutSignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
  }
>();

onMounted(() => {
  const elm = document.getElementById('error-form-container');
  if (!elm) {
    ErrorUtil.internalError({ msg: 'Could not find error-form-container' });
    return;
  }
  elm.classList.remove('d-none');
});
</script>

<style></style>
